import ADPMemoService from "../../../../../services/admin/ADPMemoService";

class bulletinService {

    async getClientState(): Promise<any> {
        const clientState = localStorage.getItem('clientState');
        return clientState ? JSON.parse(clientState) : null
    }

    async findAll(recordFilter: any): Promise<any> {
        return await ADPMemoService.findAll(recordFilter);
    }

    async create(item: any): Promise<any> {
        return await ADPMemoService.create(item);
    }


}

export default new bulletinService();